import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';
import type { VideaNoteSectionFieldsSnapshot } from '@/react-query/videa-notes/types';

export interface UpdateNotesBody {
  editedSummary?: string | null;
  editedTemplate?: Array<{
    sectionId: string;
    bodyTemplate: string;
  }> | null;
  editedFields?: Array<{
    sectionId: string;
    fields: Array<{
      key: string;
      editedValue: string | null;
    }>;
  }> | null;
  fields?: VideaNoteSectionFieldsSnapshot[] | null;
}

export const useUpdateNotes = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useMutation({
    mutationFn: async ({
      clinicalNoteId,
      updateNotesBody,
    }: {
      clinicalNoteId: string;
      updateNotesBody: UpdateNotesBody;
    }) => {
      return makeAPIRequestReactQuery(
        `/videa-notes/${clinicalNoteId}/summary`,
        {},
        'patch',
        {
          data: updateNotesBody,
          headers: {
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
    },
  });
};
